module.exports = __webpack_public_path__ + "img/Releasefreeze.0831f89b.png";